import { render } from "./NFI.vue?vue&type=template&id=1666b054"
import script from "./NFI.vue?vue&type=script&lang=js"
export * from "./NFI.vue?vue&type=script&lang=js"

import "./NFI.vue?vue&type=style&index=0&id=1666b054&lang=css"
script.render = render

export default script